<template>
  <div
    class="filter-value"
    :class="customClass"
  >
    <template v-if="currentFilters.length > 0">
      <div
        v-for="(filter, index) of currentFilters"
        :key="`quicksearch-filter-${index}`"
      >
      <span  class="filter-value__options" v-if="secondaryCollection && filter.name == 'Compatibility' && !isMobile" >
        <h2
          
          class="text-heading-2xs"
          v-text="filterLabel(filter.name)"
        />
        <splide
        
          :has-track="false"
          :options="splideConfig"
        >
          <splide-track>
            <splide-slide
              v-for="(option, i) of filter.options"
              :key="`filter-${i}`"
              class="filter-value__option"
            >
              <btn
                class="filter-value__btn"
                :id="`btn-${option.paramname}-${option.value}`"
                :class="{'selected': selected === option.value, [`value-${option.value}`]: true}"
                modifiers="secondary reversed fill"
                :value="option.value"
                show-icon
                :label="getLabel(option.value, option.label)"
                @click="updateFilter(option.paramname, option.value)"
              >
                <template #icon>
                  <icon-minus v-if="selected === option.value " />
                  <icon-plus v-else />
                </template>
              </btn>
            </splide-slide>
          </splide-track>
        </splide>
      </span>
      <span  class="filter-value__options" v-if="!secondaryCollection" >
        <h2
          class="text-heading-2xs"
          v-text="filterLabel(filter.name)"
        />
        <div
          v-for="(option, i) of filter.options"
          :key="`quicksearch-filter-options-${i}`"
          class="filter-value__option"
        >
          <btn
            class="filter-value__btn "
            :id="`btn-${option.paramname}-${option.value}`"
            :class="{'selected': selected === option.value, [`value-${option.value}`]: true}"
            modifiers="secondary reversed fill"
            :value="option.value"
            show-icon
            :label="getLabel(option.value, option.label)"
            @click="updateFilter(option.paramname, option.value)"
          >
            <template #icon>
              <icon-minus v-if="selected === option.value" />
              <icon-plus v-else />
            </template>
          </btn>
        </div>
      </span>
      <span  class="filter-value__options" v-if="isMobile && secondaryCollection && filter.name == 'Compatibility' " >
        <h2
          class="text-heading-2xs"
          v-text="filterLabel(filter.name)"
        />
        <div
          v-for="(option, i) of filter.options"
          :key="`quicksearch-filter-options-${i}`"
          class="filter-value__option"
        >
          <btn
            class="filter-value__btn "
            :id="`btn-${option.paramname}-${option.value}`"
            :class="{'selected': selected === option.value, [`value-${option.value}`]: true}"
            modifiers="secondary reversed fill"
            :value="option.value"
            show-icon
            :label="getLabel(option.value, option.label)"
            @click="updateFilter(option.paramname, option.value)"
          >
            <template #icon>
              <icon-minus v-if="selected === option.value" />
              <icon-plus v-else />
            </template>
          </btn>
        </div>
      </span>
    </div>
    </template>

    <div
      v-else
      class="filter-value__options"
    >
      <p
        class="text-heading-2xs"
        v-text="$string('collection.filter.no_filter')"
      />
    </div>
  </div>
</template>

<script>

import Btn from '~global/btn/btn'
import IconPlus from '~icons/directional-navigation/plus.svg'
import IconMinus from '~icons/directional-navigation/minus.svg'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import { mapActions, mapGetters, mapState } from 'vuex'

/**
 * Vue: Collection filter (filter-value)
 * -----------------------------------------------------------------------------
 * Filter bar to appear on PLPs and Search page.
 *
 */
export default {
  name: 'FilterValue',
  components: {
    Btn,
    IconMinus,
    IconPlus,
    Splide,
    SplideSlide,
    SplideTrack,
  },

  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    customClass: {
      type: String,
      default: '',
    },
    secondaryCollection: {
      type: Boolean,
      default: false,
    },
  },

  emits: {
    'update-filters': () => true,
  },

  data() {
  
    return {
      splideConfig: {
        arrows: false,
        autoWidth: true,
        drag: true,
        gap: 'var(--spacing-m)',
        pagination: false,
      },
      selected: false,
      currentFilters: [],
    }
  },
 
  computed: {

/**
 * Map Vuex state.
 */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),


  },
  mounted() {
  // console.log('filters', this.filters)
   if(this.filters != null){
      const uniqueValuesBySection = this.processDataPreservingStructure(this.filters);
      this.currentFilters = uniqueValuesBySection
      //console.log('uniqueValuesBySection',uniqueValuesBySection)
   }
   const checkFilters = setInterval(() => {
        if (this.filters != null) {
          //console.log("Filters are now available:", this.filters);
          const uniqueValuesBySection = this.processDataPreservingStructure(this.filters);
           this.currentFilters = uniqueValuesBySection
          clearInterval(checkFilters); 
        } 
      }, 500); 
    
  },

  methods: {
    processDataPreservingStructure(data) {
  // Create a deep copy of the original data to avoid modifying it directly
  const processedData = JSON.parse(JSON.stringify(data));
  
      // Process each section in the data
      processedData.forEach(section => {
        // Create a map to store unique options by their non-pipe-split values
        const uniqueOptionsMap = new Map();
        
        // First pass: identify all unique values across pipe-separated options
        section.options.forEach(option => {
          if (option.value.includes('|')) {
            const values = option.value.split('|');
            values.forEach(value => {
              // If this is a new unique value, add it to our map
              if (!uniqueOptionsMap.has(value)) {
                uniqueOptionsMap.set(value, {
                  label: value,
                  value: value,
                  count: 0, // We'll sum counts later
                  selected: false,
                  paramname: option.paramname,
                  filtertype: option.filtertype
                });
              }
              
              // Add this option's count to the individual value's count
              uniqueOptionsMap.get(value).count += option.count;
            });
          } else {
            // For non-pipe values, just add them directly if they don't exist
            if (!uniqueOptionsMap.has(option.value)) {
              uniqueOptionsMap.set(option.value, {
                label: option.label,
                value: option.value,
                count: option.count,
                selected: option.selected,
                paramname: option.paramname,
                filtertype: option.filtertype
              });
            } else {
              // If this value already exists, add its count
              uniqueOptionsMap.get(option.value).count += option.count;
            }
          }
        });
        
        // Replace the options array with our processed unique options
        section.options = Array.from(uniqueOptionsMap.values());
      });
      this.currentFilters = processedData;
      return processedData;
    },


// Process the data

    updateFilter(key, value) {
      this.$emit('update-filters', key, value)
    },

    getLabel(key, value) {
      if (key !== 'sawmill_model' || key !== 'sawmill_model_new') {
        return value
      }

      return value.split('|').join(' | ')
    },

    filterLabel(label) {
      return `${this.$string('collection.filter.label')} ${label}`
    },
  },
}
</script>

<style lang="scss">
@import './filter-value';
</style>
